import { EAccountIsActive } from '../../enum'

// Create a union type of all possible values from the enum
type IAccountIsActiveLangKey = `${EAccountIsActive}`

export type IAccountIsActiveLang = {
	account_is_active: Record<IAccountIsActiveLangKey, string>
}

const langEntries = Object.entries(EAccountIsActive).map(
	([key, value]) => [value, `account_is_active.${value}`]
)

const langObj: Record<IAccountIsActiveLangKey, string> = Object.fromEntries(langEntries)

export const ACCOUNT_IS_ACTIVE_LANG_KEY: IAccountIsActiveLang = {
	account_is_active: langObj
}
